import {
    useCallback,
} from 'react'
import useDelayedLoadOptions from 'app/hooks/useDelayedLoadOptions'
import {
    useJWTToken,
} from 'app/Auth'
import simpleApi from 'app/services/simpleApi'
import countriesRequest, {
    countrySelectionConfig,
} from 'app/requests/Country.requests'

export default () => {
    const token = useJWTToken()
    const loadOptions = useDelayedLoadOptions(countrySelectionConfig)

    const loadLabel = useCallback((id) => {
        return simpleApi({
            url: countriesRequest.get({
                id,
            }).url,
            token,
        })
    }, [token])

    return {
        loadOptions,
        loadLabel,
    }
}
